import React, { useState } from 'react';

import { IoMdArrowDropup, IoMdArrowDropdown } from 'react-icons/io';

import { Container, Content, Title, Right, Control } from './styles';

import { SubmenuProps } from './interface';

const Submenu: React.FC<SubmenuProps> = ({ children, title }) => {
  
  const [visible, setVisible] = useState(false);

  const toggleCollapse = () => {
    setVisible(!visible);
  };

  return (
    <Container>
      <Title>
        <Control onClick={toggleCollapse}>
          <Title>{title}</Title>
          <Right>
            {visible ? (
              <IoMdArrowDropup size={32} color={'#fff'} />
            ) : (
              <IoMdArrowDropdown size={32} color={'#fff'} />
            )}
          </Right>
        </Control>
      </Title>

      {visible ? (
        <Content>
          <>{children}</>
        </Content>
      ) : null}
    </Container>
  );
};

export default Submenu;
